import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import newsController from '../../api/newsController';
let publicUrl = process.env.PUBLIC_URL + '/'
let imagealt = 'image'
function BannerV3() {
	const [news, setNews] = React.useState([]);
	React.useEffect(() => {
		let news = newsController.getNews();
		setNews(news);
	}, [])
	const renderNews = () => {
		let news2 = news.slice(0, 3);
		return news2.map((item, index) => {
			return (<div className="col-lg-12 col-sm-6">
				<div className="thumb">
					<img style={{ cursor: "pointer" }} onClick={() => { window.open(item.link, '_blank') }} className="w-100" src={item.photo_url} alt="img" />
				</div>
			</div>)
		})
	}
	const renderSinglePost = () => {
		let singlePost = news[4];
		console.log(singlePost);
		if (singlePost) {
			return (
				<div className="col-lg-5">
					<div className="single-post-wrap style-overlay-bg">
						<div className="thumb">
							<img style={{ width: "100%" }} src={singlePost.photo_url} alt="img" />
						</div>
						<div className="details">
							<div className="post-meta-single mb-3">
								<ul>
									<li><p> - {Math.floor(Math.random() * (10000 - 1000 + 1)) + 1000}</p></li>
								</ul>
							</div>
							<h5 className="title"><a target='_blank' href={singlePost.link}>{singlePost.title}</a></h5>
							<div className="media author-meta mt-2">
								<div className="media-body align-self-center">
									<p className="m-0"><span>{singlePost.authors[0]}</span> - {new Date(singlePost.published_datetime_utc).toLocaleDateString()}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			);
		} else {
			return null
		}

	}
	const renderMultiplePost = () => {
		let multiplePosts = news.slice(5, 7);
		if (multiplePosts.length > 0) {
			multiplePosts = multiplePosts.map((singlePost, index) => {
				if (singlePost) {
					return (
						<div className="single-post-wrap style-overlay">
							<div className="thumb">
								<img src={singlePost.photo_url} alt="img" />
							</div>
							<div className="details">
								<div className="post-meta-single">
								</div>
								<h6 className="title"><a target="_blank" href={singlePost.link}>{singlePost.title} </a></h6>
								<p className="mt-0">By {singlePost.authors[0]}</p>
							</div>
						</div>
					);
				}
			})
			return (
				<div className="row">
					{multiplePosts}
				</div>
			);
		} else {
			return null
		}

	}
	return (<div className="banner-area banner-inner-3">
		<div className="container-fluid p-0">
			<div className="row custom-gutters-20">
				<div className=" offset-lg-1 col-lg-2">
					<div className="row">
						{renderNews()}
					</div>
				</div>
				{renderSinglePost()}
				<div className="col-lg-3 col-sm-7">
					{renderMultiplePost()}
				</div>

			</div>
		</div>
	</div>)


}

export default BannerV3